import React from 'react';
import { string, number, func } from 'prop-types';

import { Wrapper, SCTextField, Title, Spacing, Description } from './styles';

TextField.propTypes = {
  title: string,
  description: string,
};

TextField.defaultProps = {
  title: '',
  description: null,
};

function TextField({ title, description, ...rest }) {
  return (
    <Spacing>
      <Title>{title}</Title>
      {description && <Description>{description}</Description>}
      <Wrapper>
        <SCTextField {...rest} />
      </Wrapper>
    </Spacing>
  );
}

export default TextField;



// WEBPACK FOOTER //
// ./src/components/TextField/TextField.js